<section class="section about" id='about' (keydown)="onKeyDown($event)" tabindex="0">
    <div class="container">
        <div class="section-box">
            <div class="about-title" data-animate="slideInUp" data-animate-duration="1000">
                <h3 class="section-title">
                    <span class='n-section-title'>01.</span> {{"AboutMe.Title" | translate}}
                </h3>
            </div>

            <div class="row">
                <div class="col-12 col-md-6 mb-4 mb-md-0">

                    <div class="about-description">


                        <!-- EDUCATION FIRST -->
                        <!-- EDUCATION -->
                        <div class="about-education" data-animate="fadeInUp" data-animate-delay="300">
                            <h4 class="about-subtitle">
                                <span class="underline">{{ 'AboutMe.EducationTitle' | translate }}</span>
                            </h4>

                            <div class="education-item-container">
                                <div class="education-item"
                                    *ngFor="let edu of 'AboutMe.Education' | translate; let i = index"
                                    data-animate="fadeInUp" [attr.data-animate-delay]="300 + (i * 200)"
                                    data-animate-duration="800">

                                    <!-- Animate each child inside -->
                                    <h5 class="degree-title" data-animate="fadeInUp"
                                        [attr.data-animate-delay]="400 + (i * 200)" data-animate-duration="600">
                                        {{ edu.Degree }}
                                    </h5>

                                    <p class="degree-school" data-animate="fadeInUp"
                                        [attr.data-animate-delay]="500 + (i * 200)" data-animate-duration="600">
                                        {{ edu.School }}
                                    </p>

                                    <span class="degree-year" data-animate="fadeInUp"
                                        [attr.data-animate-delay]="600 + (i * 200)" data-animate-duration="600">
                                        {{ edu.Year }}
                                    </span>
                                </div>

                            </div>

                        </div>



                        <div class="about-paragraph" data-animate="fadeInUp" data-animate-delay="500">
                            <h4 class="about-subtitle">
                                <span class="underline">Profile</span>
                            </h4>
                        </div>

                        <div class="about-text-card">
                            <p *ngFor='let text of "AboutMe.Paragraphs" | translate; let i = index' [innerHTML]="text"
                                data-animate="fadeInLeft" [attr.data-animate-delay]="200 + (i * 300)"
                                data-animate-duration="800">
                            </p>
                        </div>


                    </div>
                </div>
                <div class="col-12 col-md-6 mt-4 mt-md-0 text-center" data-animate="morphIn"
                    data-animate-duration="1200" data-animate-delay="600">
                    <div class="about-img-wrapper">
                        <div class="about-img-container">
                            <img (click)='onImageClick()' class="rounded about-image clickable" width="50%"
                                src="assets/images/Molka2.jpg" alt="Molka Jlassi"
                                title="Click para ver imagen ampliada">
                        </div>
                    </div>
                </div>
                <!-- ✅ FULL WIDTH SKILLS (NEW ROW) -->
                <!-- SKILLS -->
                <div class="skills-grid">

  <div class="skill-card">
    <h5><i class="fas fa-code"></i> Languages</h5>
    <p>
      <i class="fab fa-java"></i> Java,
      <i class="fab fa-python"></i> Python,
      <i class="fab fa-js"></i> JavaScript
    </p>
  </div>
    <div class="skill-card">
    <h5><i class="fas fa-vial"></i> QA</h5>
    <p>
      Selenium,
      TestNG,
      Postman,
      Swagger,
      Mockito,
      Xray
    </p>
  </div>
  <div class="skill-card">
    <h5><i class="fas fa-layer-group"></i> Frameworks</h5>
    <p>
      Spring Boot,
      Angular,
      Node.js,
      Symfony
    </p>
  </div>

  

  <div class="skill-card">
    <h5><i class="fas fa-tools"></i> Tools</h5>
    <p>
      Git,
      GitHub,
      GitLab,
      Jira,
      Trello
    </p>
  </div>

  <div class="skill-card">
    <h5><i class="fas fa-cogs"></i> DevOps</h5>
    <p>
      Docker,
      Jenkins,
      CI/CD,
      SonarQube
    </p>
  </div>

  <div class="skill-card">
    <h5><i class="fas fa-database"></i> Databases</h5>
    <p>
      PostgreSQL,
      MongoDB,
      MySQL
    </p>
  </div>

  <div class="skill-card">
    <h5><i class="fas fa-chart-line"></i> Monitoring</h5>
    <p>
      Grafana,
      Prometheus
    </p>
  </div>

  <div class="skill-card">
    <h5><i class="fas fa-project-diagram"></i> Methodology</h5>
    <p>
      Agile,
      Scrum
    </p>
  </div>

</div>
            </div>
        </div>
    </div>

    <!-- Modal para imagen ampliada -->
    <div class="image-modal-overlay" *ngIf="isImageModalOpen" (click)="onModalBackdropClick($event)" [@fadeInOut]>
        <div class="image-modal-container">
            <button class="modal-close-btn" (click)="closeImageModal()" aria-label="Cerrar modal">
                <span>&times;</span>
            </button>
            <img class="modal-image" src="assets/images/Molka2.jpg" alt="José Andrés - Imagen ampliada" [@zoomIn]>
        </div>
    </div>
</section>